





































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import DrawingCanvas from "@/components/drawing-canvas/DrawingCanvas.vue";
import { PemeriksaanFisik as PemFisikTypes } from "@/types/pemeriksaan_fisik";

@Component({
  components: {
    DrawingCanvas
  }
})
export default class PemeriksaanFisik extends Vue {
  @Prop() value: PemFisikTypes;

  kepala = null;
  leher = null;
  dada = null;
  paru = null;
  jantung = null;
  perut = null;
  genital = null;
  ektrimitaAtas = null;
  ektrimitaBawah = null;
  tubuhBelakang = null;
  statusPubertas = null;
  fisikImage = null;

  canvasWidth = 650;
  canvasHeight = 440;

  get values(): PemFisikTypes {
    return {
      kepala: this.kepala,
      leher: this.leher,
      dada: this.dada,
      paru: this.paru,
      jantung: this.jantung,
      perut: this.perut,
      genital: this.genital,
      ektrimitaAtas: this.ektrimitaAtas,
      ektrimitaBawah: this.ektrimitaBawah,
      tubuhBelakang: this.tubuhBelakang,
      statusPubertas: this.statusPubertas,
      fisikImage: this.fisikImage
    };
  }

  addDbn(field) {
    if (!this[field]) {
      this[field] = "";
      this[field] = this[field].concat(" Dalam batas normal").trim();

      // biar update ke parent nya
      this.changeInputField();
    } else {
      alert(
        "Mohon hapus isian sebelumnya terlebih dahulu untuk menetapkan ini sebagai DBN"
      );
    }
  }

  updateDrawedImage(image) {
    this.fisikImage = image;

    this.changeInputField();
  }

  changeInputField() {
    this.$emit("changeValue", this.values);
  }

  @Watch("value", { deep: true })
  changeValue(val: PemFisikTypes) {
    this.kepala = val.kepala;
    this.leher = val.leher;
    this.dada = val.dada;
    this.paru = val.paru;
    this.jantung = val.jantung;
    this.perut = val.perut;
    this.genital = val.genital;
    this.ektrimitaAtas = val.ektrimitaAtas;
    this.ektrimitaBawah = val.ektrimitaBawah;
    this.tubuhBelakang = val.tubuhBelakang;
    this.statusPubertas = val.statusPubertas;
    this.fisikImage = val.fisikImage;
  }
}
